<template>
  <article class="d-flex testimonials-swiper-card">
    <div class="icons-container d-flex me-4" :class="{'position-static': shouldHaveQuates}">
      <ReactSlicedIcon class="me-2 me-md-3"/>
      <ReactSlicedIcon/>
    </div>
    <div class="d-flex flex-column pt-md-0 ps-md-0" :class="{'pt-2 ps-2': !shouldHaveContainer}">
      <p v-html="card.description" class="flex-stretch"></p>
      <div class="stars">
        <StarFilledIcon v-for="starFilled in card.stars" :key="`${card.id}${starFilled}`"/>
        <StarIcon v-if="card.stars < 5" v-for="star in 5 - card.stars"/>
      </div>
      <p class="h5" v-if="card.name">{{ card.name }}</p>
      <p v-if="card.companyName">{{ card.companyName }}</p>
    </div>
  </article>
</template>

<script>
import ReactSlicedIcon from "@/assets/icons/react-sliced-icon";
import StarFilledIcon from "@/assets/icons/star-filled-icon";
import StarIcon from "@/assets/icons/star-icon";

export default {
  components: {StarIcon, StarFilledIcon, ReactSlicedIcon},
  props: {
    card: {
      id: String,
      description: HTMLElement,
      companyName: String,
      stars: Number,
      name: String
    },
    shouldHaveContainer: Boolean,
    shouldHaveQuates: Boolean,
  }
}
</script>
